import apiClient from "@/utils/axiosInterceptor";
import {API} from "@/api/API";

export const SettingsButtonsMethods = {
    getButtons: async (id, type) => {
        return await apiClient.get(API.getButtonsColors.path(id, type));
    },

    createButtons: async (params, event_id, type) => {
        console.log(params)
        const serialized = serializeData(params, event_id);
        return await apiClient.post(API.createButtonsColors.path(event_id, type), serialized);
    },

    patchButtons: async (params, event_id, type) => {
        const serialized = serializeData(params, event_id, true);
        return await apiClient.patch(API.patchButtonsColors.path(params.id), serialized);
    },

    deleteButtons: async (id) => {
        return await apiClient.delete(API.deleteButtonsColors.path(id));
    }
};

const serializeData = (params, event_id, includeId = false) => ({
    data: {
        type: "buttons",
        ...(includeId && { id: params.id }),
        attributes: {
            event_id: Number(event_id),
            pos: params.position,
            type_id: params.type_id,
            name: params.name,
            background_color: params.background_color,
            font_color: params.font_color,
            boxShadowColor: params.box_shadow_color || null,
            sortable: true
        }
    }
});
